import React from "react";
import { state_training_children } from "../../../../constants";
import { ReactComponent as Unpaid } from "../../../../../../../components/icon/invoiceUnpaid.svg";
import { ReactComponent as TrialLessonIcon } from "../../../../../../../components/icon/trialLessonIcon.svg";
import { ReactComponent as InvoiceGift } from "../../../../../../../components/icon/invoiceGift.svg";
import { ReactComponent as UserInfoIcon } from "../../../../../../../components/icon/userInfo.svg";
const chooseChildrenIcon = (item) => {
  const isUnpaid = item.type === "common" && item.invoice?.state.id === 1;
  const isTrial = item.type === "trial";
  const isGift =
    item.type === "common" &&
    item.invoice_stat?.common === 1 &&
    item.invoice?.state.id === 2 &&
    item.invoice?.count >= 8;

  if (isGift) {
    return <InvoiceGift />;
  }

  if (isUnpaid) {
    return <Unpaid />;
  }

  if (isTrial) {
    return <TrialLessonIcon />;
  }
  return null;
};
const AttendanceChild = ({
  item,
  onChildClick,
  onUserInfoClick,
  onStatusChange,
  loadingStatus,
}) => {
  const childStatus = state_training_children.find(
    (el) => el.id === item.state_training_children.id
  )?.name;

  const isChildStatusDisabled =
    loadingStatus || item.state_training_children.id === 3;
  return (
    <div className="attendanceTrainingContainer">
      <h4 onClick={onChildClick}>
        {item.children.last_name} {item.children.first_name}
      </h4>
      <div className="attendance-child__actions">
        <UserInfoIcon
          className="trainingChildInfoIcon"
          onClick={onUserInfoClick}
        />
        {chooseChildrenIcon(item)}
        <button onClick={onStatusChange} disabled={isChildStatusDisabled}>
          {childStatus}
        </button>
      </div>
    </div>
  );
};

export default AttendanceChild;
